var map = {
	"./image-cards.de-CH.json": 1208,
	"./image-cards.de-DE.json": 1209,
	"./image-cards.en-CA.json": 1210,
	"./image-cards.en-GB.json": 1211,
	"./image-cards.en-IN.json": 1212,
	"./image-cards.en-ME.json": 1213,
	"./image-cards.en-US.json": 1214,
	"./image-cards.es-EM.json": 1215,
	"./image-cards.es-ES.json": 1216,
	"./image-cards.fr-BE.json": 1217,
	"./image-cards.fr-CA.json": 1218,
	"./image-cards.fr-CH.json": 1219,
	"./image-cards.nl-BE.json": 1220,
	"./image-cards.nl-NL.json": 1221,
	"./image-cards.pl-PL.json": 1222,
	"./image-cards.pt-BR.json": 1223
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1207;